import React from 'react'
import { Icon, Typography } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const useStyles = makeStyles(() => ({
    IconAndSubText: {},
    ISIconCenter: {
        display: 'block',
        margin: 'auto',
    },
    ISIcon: {
        display: 'block'
    },
    ISSubTextCenter: {
        textAlign: 'center',
        fontSize: 10,
    },
    ISSubText: {
        textAlign: 'left',
        fontSize: 10,
    },
    vdBody: {
        display: 'block',
        margin: 'auto',
    },
}))

export function IconWithSubtext({ icon, label, color, id, dwpErrorCode, tooltip = null, center = true }) {
    const classes = useStyles()
    const { t } = useTranslation()

    return (
        <Tooltip title={tooltip ?? ''} interactive>
            <div className={classes.IconAndSubText}>
                {id === 'Failed' && dwpErrorCode ? (
                    <Tooltip title={t(`errorCodeATI:${dwpErrorCode}`)} arrow>
                        <Icon className={center ? classes.ISIconCenter : classes.ISIcon} style={{ color: color }}>
                            {icon}
                        </Icon>
                    </Tooltip>
                ) : (
                    <Icon className={center ? classes.ISIconCenter : classes.ISIcon} style={{ color: color }}>
                        {icon}
                    </Icon>
                )}
                <Typography className={center ? classes.ISSubTextCenter : classes.ISSubText} style={{ color: color }}>
                    {label}
                </Typography>
            </div>
        </Tooltip>
    )
}

IconWithSubtext.propTypes = {
    label: PropTypes.string,
    icon: PropTypes.string,
    color: PropTypes.string,
    id: PropTypes.string,
    dwpErrorCode: PropTypes.string,
    tooltip: PropTypes.string,
    center: PropTypes.bool,
}

export function SwitchMode({ label, icon, color }) {
    const classes = useStyles()

    return (
        <div className={classes.vdBody}>
            <IconWithSubtext icon={icon} label={label} color={color} />
        </div>
    )
}

SwitchMode.propTypes = {
    label: PropTypes.string,
    icon: PropTypes.string,
    color: PropTypes.string,
}
